<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YqIUi1/tc-custom/9780544263789.jpg?1718282808326" alt="This image is the cover for the book Fortunes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fortunes
      </h1>
      <p class="bookDescription body article font2">
        <b>Winner of the Anisfield-Wolf Book Award</b><br/><b><i>for literature that confronts racism and examines diversity</i></b><br/><br/><b>Winner of the 2017 Chautauqua Prize</b><br/><br/><b>Finalist for the Dayton Literary Peace Prize</b><br/><br/><b>A <i>New York Times </i>Notable Book </b><br/><b>"Riveting and luminous...Like the best books, this one haunts the reader well after the end."—Jesmyn Ward</b><br/><br/><b>“[A] complex, beautiful novel . . . Stunning.”—NPR, Best Books of 2016<br/><br/> “Intense and dreamlike . . . filled with quiet resonances across time.”—<i>The New Yorker</i></b> <br/> Sly, funny, intelligent, and artfully structured, <i>The Fortunes </i>recasts American history through the lives of Chinese Americans and reimagines the multigenerational novel through the fractures of immigrant family experience.<br/><br/> Inhabiting four lives—a railroad baron’s valet who unwittingly ignites an explosion in Chinese labor; Hollywood’s first Chinese movie star; a hate-crime victim whose death mobilizes the Asian American community; and a biracial writer visiting China for an adoption—this novel captures and capsizes over a century of our history, showing that even as family bonds are denied and broken, a community can survive—as much through love as blood.<br/><br/><b>“A prophetic work, with passages of surpassing beauty.”—Joyce Carol Oates, Anisfield-Wolf Book Award citation<br/>  <br/> “A poignant, cascading four-part novel . . . Outstanding.”—David Mitchell, <i>Guardian</i><br/><br/> “The most honest, unflinching, cathartically biting novel I’ve read about the Chinese American experience.”—Celeste Ng</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Ho Davies
      </h2>
      
      <p class="authorDescription body article"><P><B>PETER HO DAVIES</B><B>&rsquo;s</B> novel,&#160;<I>The Fortunes</I>, won the Anisfield-Wolf Award and the Chautauqua Prize and was a <I>New York Times</I> Notable Book of the Year.&#160;He is also the author of <I>The Welsh Girl</I>, long-listed for the Man Booker Prize and a London <I>Times</I> best-seller, as well as two critically acclaimed collections of short stories. His fiction has appeared in&#160;<I>Harpers</I>, the<I> Atlantic</I>, the<I> Paris Review,</I> and <I>Granta</I> and has been anthologized in&#160;<I>Prize Stories: The O. Henry Awards&#160;</I>and<I>&#160;The Best American Short Stories</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f945f688